import { Box } from '@mui/material';
import { type JSX, type SyntheticEvent } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTopHeader } from 'app/hooks';
import { Tabs } from 'app/shared-components/structure';
import type { HealtheraTab } from 'app/shared-components/structure/Tabs';
import FuseSuspense from '@/@fuse/core/FuseSuspense';
import LunarRunStats from '../components/LunarRunStats';
import useLunarRunStats from '../hooks/useLunarRunStats';

const TAB_VALUES = ['pending', 'reviewed'];

export default function LunarReviewsLayout(): JSX.Element {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { data: stats } = useLunarRunStats();
  useTopHeader('Lunar Reviews');

  // Counts appear once the stats load and stay off the tabs if they fail.
  const tabs: HealtheraTab[] = [
    { label: 'Pending', value: 'pending', count: stats?.pendingCount },
    { label: 'Reviewed', value: 'reviewed', count: stats?.reviewedCount },
  ];

  const lastSegment = pathname.split('/').pop() ?? '';
  const selectedTab = TAB_VALUES.includes(lastSegment) ? lastSegment : 'pending';

  const handleTabChange = (_event: SyntheticEvent, newTab: string): void => {
    navigate(`/lunar-reviews/${newTab}`);
  };

  return (
    <Box className="vtwo:grow vtwo:flex vtwo:flex-col vtwo:overflow-hidden vtwo:px-5 vtwo:py-4 vtwo:gap-4">
      <LunarRunStats />
      <Tabs tabs={tabs} selectedTab={selectedTab} handleChange={handleTabChange} />
      <FuseSuspense>
        <Outlet />
      </FuseSuspense>
    </Box>
  );
}
